import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { FormControl, FormLabel, MenuItem, Select } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { Backspace, Close } from "@mui/icons-material";
import { withStyles } from "tss-react/mui";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle";
import Button from "../../../components/CustomButtons/Button";
import CustomSwitch from "../../../components/CustomInput/CustomSwitch";
import SaveButton from "../../../components/CustomInput/SaveButton";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import TagList from "../../../components/TagList/TagList";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import * as actions from "../../../store/actions";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

function MassEdit({ ...props }) {
  const { classes } = props;
  const form = useRef(null);
  const [formData, setFormData] = useState({});
  const [activeItems, setActiveItems] = useState({});
  const [saving, setSaving] = useState(false);
  const [loadingZones, setLoadingZones] = useState(false);
  const [sameSalesarea, setSameSalesarea] = useState(false);
  const [vestigingId, setVestigingId] = useState([]);
  const [zonesItems, setZonesItems] = useState([]);

  const toggleActiveItem = (field, state) => {
    let prevState = { ...activeItems };
    prevState[field] = state;
    setActiveItems(prevState);
  };

  const handleZonesList = (name) => (value) => {
    setZonesItems(value);
  };

  const validInputNames = ["is_actief", "untillTableRoulation", "payDirect", "zones"];

  const needsSameSalesarea = ["zones"];

  useEffect(() => {
    const data = [
      {
        field: "id",
        operator: "in",
        value: props.tafelIds,
      },
    ];

    axios.post("core/tafels/search?fields=vestiging_id&distinct=true", data).then((response) => {
      let sameSalesarea = response.data.data.data.length === 1;
      setSameSalesarea(sameSalesarea);

      if (sameSalesarea) {
        setVestigingId(response.data.data.data[0].vestiging_id);
      }
    });
  }, []);

  const canSave = () => {
    return (
      validInputNames.filter((input) => {
        return activeItems[input] === undefined || !activeItems[input];
      }).length !== validInputNames.length
    );
  };

  const inputSelect = validInputNames
    .filter((input) => {
      return activeItems[input] === undefined || !activeItems[input];
    })
    .filter((input) => {
      return !needsSameSalesarea.includes(input) || sameSalesarea;
    })
    .map((input) => {
      return (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={input}
          value={input}
        >
          <TranslationWrapper tDefault={input} tKey={"tafels.form.algemeen.label." + input} />
        </MenuItem>
      );
    });

  const save = (e) => {
    e.preventDefault();
    setSaving(true);

    let formElements = form.current.elements;
    const data = {
      ids: props.tafelIds,
      values: [],
    };

    [...formElements].forEach((e) => {
      if (validInputNames.includes(e.name)) {
        data.values.push({
          field: e.name,
          value: e.value,
        });
      }
    });

    axios.post("core/tafels/mass_edit", data).then((response) => {
      props.toggle();
      props.refreshTable();
      toast.success(response.data.data.message);
      setSaving(false);
    });
  };

  const getZones = () => {
    if (!loadingZones) {
      setLoadingZones(true);
      axios
        .get(
          "core/zones?per_page=5000&fields=id,zoneName as label&sort_field=zoneName&sort_dir=asc&vestiging_id=" +
            vestigingId
        )
        .then((response) => {
          setZonesItems(response.data.data.data);
        });
    }
  };

  return (
    <Dialog
      TransitionComponent={Transition}
      aria-describedby={"notice-modal-slide-description"}
      aria-labelledby={"notice-modal-slide-title"}
      fullWidth={true}
      keepMounted
      maxWidth={"lg"}
      onClose={props.toggle}
      open={props.open}
    >
      <form onSubmit={save} ref={form}>
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper tDefault={"Tafels aanpassen"} tKey={"tafels.massedit.modal.header"} />
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          <GridContainer>
            <GridItem className={classes.selectInputGridItem} sm={12} xs={12}>
              <FormControl className={classes.selectFormControl} fullWidth>
                <Select
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  classes={{
                    select: classes.select,
                  }}
                  displayEmpty
                  onChange={(e) => {
                    toggleActiveItem(e.target.value, true);
                  }}
                  value={""}
                >
                  <MenuItem
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected,
                    }}
                    disabled
                    key={"empty"}
                    value={""}
                  >
                    <TranslationWrapper
                      tDefault={"Kies wat je wilt aanpassen."}
                      tKey={"producten.massedit.modal.noselect"}
                    />
                  </MenuItem>
                  {inputSelect}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
          {activeItems.is_actief ? (
            <GridContainer>
              <GridItem sm={2} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Table active"} tKey={"tafels.form.algemeen.label.is_actief"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={9} xs={12}>
                <CustomSwitch
                  checked={formData.is_actief ? formData.is_actief : false}
                  name={"is_actief"}
                  onChange={() => {
                    setFormData({
                      ...formData,
                      is_actief: event.target.checked,
                    });
                  }}
                />
              </GridItem>
              <GridItem sm={1} xs={12}>
                <Button
                  className={classes.actionButton}
                  color={"danger"}
                  onClick={() => toggleActiveItem("is_actief", false)}
                  simple
                  style={{
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <Backspace className={classes.icon} />
                </Button>
              </GridItem>
            </GridContainer>
          ) : null}
          {activeItems.untillTableRoulation ? (
            <GridContainer>
              <GridItem sm={2} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper
                    tDefault={"Tafel roulatie"}
                    tKey={"tafels.form.algemeen.label.untillTableRoulation"}
                  />
                </FormLabel>
              </GridItem>
              <GridItem sm={9} xs={12}>
                <CustomSwitch
                  checked={formData.untillTableRoulation ? formData.untillTableRoulation : false}
                  name={"untillTableRoulation"}
                  onChange={() => {
                    setFormData({
                      ...formData,
                      untillTableRoulation: event.target.checked,
                    });
                  }}
                />
              </GridItem>
              <GridItem sm={1} xs={12}>
                <Button
                  className={classes.actionButton}
                  color={"danger"}
                  onClick={() => toggleActiveItem("untillTableRoulation", false)}
                  simple
                  style={{
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <Backspace className={classes.icon} />
                </Button>
              </GridItem>
            </GridContainer>
          ) : null}
          {activeItems.payDirect ? (
            <GridContainer>
              <GridItem sm={2} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Betaal direct"} tKey={"tafels.form.algemeen.label.payDirect"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={9} xs={12}>
                <CustomSwitch
                  checked={formData.payDirect ? formData.payDirect : false}
                  name={"payDirect"}
                  onChange={() => {
                    setFormData({
                      ...formData,
                      payDirect: event.target.checked,
                    });
                  }}
                />
              </GridItem>
              <GridItem sm={1} xs={12}>
                <Button
                  className={classes.actionButton}
                  color={"danger"}
                  onClick={() => toggleActiveItem("payDirect", false)}
                  simple
                  style={{
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <Backspace className={classes.icon} />
                </Button>
              </GridItem>
            </GridContainer>
          ) : null}
          {activeItems.zones ? (
            <GridContainer>
              {getZones()}
              <GridItem sm={2} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Zones"} tKey={"producten.form.algemeen.label.zones"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={9} xs={12}>
                <TagList
                  dropdownText={
                    <TranslationWrapper
                      tDefault={"Select a zone"}
                      tKey={"tafels.form.menu.taglist.zones.dropdownText"}
                    />
                  }
                  hiddenFieldName={"zones"}
                  items={zonesItems}
                  onChange={(value) => {
                    setFormData({
                      ...formData,
                      zones: value,
                    });
                  }}
                  selectedItems={formData.zones ? formData.zones : []}
                  selectedText={
                    <TranslationWrapper
                      tDefault={"Selected zones"}
                      tKey={"tafels.form.menu.taglist.zones.selectedText"}
                    />
                  }
                  showHeaders={false}
                />
              </GridItem>
              <GridItem sm={1} xs={12}>
                <Button
                  className={classes.actionButton}
                  color={"danger"}
                  onClick={() => toggleActiveItem("zones", false)}
                  simple
                  style={{
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <Backspace className={classes.icon} />
                </Button>
              </GridItem>
            </GridContainer>
          ) : null}
        </DialogContent>
        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={props.tafelIds.length}
            disabled={!canSave()}
            saving={saving}
            tDefault={"item(s) Aanpassen"}
            tKey={"modal.copy.button.mass_edit"}
            type={"submit"}
          />
        </DialogActions>
      </form>
    </Dialog>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) =>
      dispatch({
        type: actions.SHOW_MESSAGE,
        message: message,
      }),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(MassEdit, notificationsStyle));
